// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-area .scroll-header .header-top {
  position: relative;
  box-shadow: none;
  z-index: 2;
}
.header-area .scroll-header .header-top .navbar-nav {
  align-items: center;
}
.header-area .scroll-header .header-top .navbar-nav .nav-link {
  color: #ffffff;
}
.header-area .scroll-header .header-top .navbar-nav .profile-img {
  background: rgba(0, 0, 0, 0.0509803922);
  border: 1px solid rgba(0, 0, 0, 0.0392156863);
  border-radius: 21px;
}
.header-area .scroll-header .header-top .navbar-nav .profile-img img {
  width: 35px;
  height: 35px;
}
.header-area .scroll-header .header-top .navbar-nav .profile-img .text .profile-name {
  font-size: 14px;
  line-height: 6px;
}
.header-area .scroll-header .header-top .search .search-bar {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.0901960784);
  box-shadow: none;
}
.header-area .scroll-header .header-top .student-notification i {
  font-size: 1.5rem;
}
.header-area .header-bottom .title {
  font: normal normal bold 22px/27px Proxima Nova;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
}
.header-area.mock-tests-eries-topnavbar .scroll-header {
  position: relative;
  background: linear-gradient(180deg, #4d5ee3, #f9c52d);
}
.header-area.previous-paper-analysis-topnavbar .scroll-header {
  position: relative;
  background: linear-gradient(180deg, #30ffe3, #c698e9);
}
.header-area.getreadyforexam-topnavbar .scroll-header {
  position: relative;
  background: linear-gradient(180deg, #ffcf10, #98e9b3);
}
.header-area.bookmarks-topnavbar .scroll-header {
  position: relative;
  background: linear-gradient(180deg, #f7af4d, #2bb19e);
}
.header-area.notes-topnavbar .scroll-header {
  position: relative;
  background: linear-gradient(180deg, #3a4ace, #fb7369);
}
.header-area.exam-topnavbar .scroll-header {
  position: relative;
  background: linear-gradient(180deg, #d10781 0%, #cd43a2 2%, #c3daf5 100%);
}
.header-area.videos-topnavbar .scroll-header {
  position: relative;
  background: linear-gradient(180deg, #d10451, #eb6d7e);
}
.header-area.videos-topnavbar .scroll-header .navbar-nav .profile-img {
  color: #000000;
  background: #ffffff;
  border: 1px solid #ffffff;
}
.header-area.notification-topnavbar .scroll-header {
  position: relative;
  background: linear-gradient(180deg, #000000 0%, #5b2cf8 100%);
}
.header-area.notification-topnavbar .scroll-header .navbar-nav .profile-img {
  color: #000000;
  background: #ffffff;
  border: 1px solid #ffffff;
}
.header-area.blog-topnavbar .scroll-header {
  position: relative;
  background: linear-gradient(180deg, #000000 0%, #f8c52c 100%);
}
.header-area.blog-topnavbar .scroll-header .navbar-nav .profile-img {
  color: #000000;
  background: #ffffff;
  border: 1px solid #ffffff;
}

.help-modal .modal-dialog-centered {
  align-items: flex-end;
}
.help-modal .modal-content {
  background-color: transparent;
  border: none;
  margin-bottom: -28px;
  pointer-events: painted;
}
.help-modal .modal-content .modal-header .close {
  padding: 0;
  color: #ff004e;
  background: #fff !important;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  line-height: 30px;
  position: absolute;
  top: 2px;
  right: 8px;
  z-index: 1;
}
.help-modal .modal-content .modal-body {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}
@media screen and (min-width: 992px) {
  .help-modal .modal-content .modal-body img {
    width: 350px;
    position: absolute;
    bottom: 6px;
    right: 0;
    z-index: 1;
  }
}
@media screen and (max-width: 991px) {
  .help-modal .modal-content .modal-body img {
    width: 320px;
  }
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/navbars/_scrolltopnavbar.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;AAEM;EACE,cAAA;AAAR;AAGM;EACE,uCAAA;EACA,6CAAA;EACA,mBAAA;AADR;AAGQ;EACE,WAAA;EACA,YAAA;AADV;AAKU;EACE,eAAA;EACA,gBAAA;AAHZ;AASI;EACE,cAAA;EACA,6CAAA;EACA,gBAAA;AAPN;AAUI;EACE,iBAAA;AARN;AAYE;EACE,+CAAA;EACA,mBAAA;EACA,cAAA;EACA,oDAAA;AAVJ;AAaE;EACE,kBAAA;EACA,qDAAA;AAXJ;AAcE;EACE,kBAAA;EACA,qDAAA;AAZJ;AAeE;EACE,kBAAA;EACA,qDAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,qDAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,qDAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,yEAAA;AAhBJ;AAmBE;EACE,kBAAA;EACA,qDAAA;AAjBJ;AAmBI;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AAjBN;AAqBE;EACE,kBAAA;EACA,6DAAA;AAnBJ;AAoBI;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AAlBN;AAsBE;EACE,kBAAA;EACA,6DAAA;AApBJ;AAqBI;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AAnBN;;AA0BE;EACE,qBAAA;AAvBJ;AA0BE;EACE,6BAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;AAxBJ;AA2BM;EACE,UAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AAzBR;AA6BI;EACE,oCAAA;EACA,qBAAA;AA3BN;AA8BQ;EADF;IAEI,YAAA;IACA,kBAAA;IACA,WAAA;IACA,QAAA;IACA,UAAA;EA3BR;AACF;AA6BQ;EATF;IAUI,YAAA;EA1BR;AACF","sourcesContent":[".header-area {\n  .scroll-header .header-top {\n    position: relative;\n    box-shadow: none;\n    z-index: 2;\n\n    .navbar-nav {\n      align-items: center;\n\n      .nav-link {\n        color: #ffffff;\n      }\n\n      .profile-img {\n        background: #0000000d;\n        border: 1px solid #0000000a;\n        border-radius: 21px;\n\n        img {\n          width: 35px;\n          height: 35px;\n        }\n\n        .text {\n          .profile-name {\n            font-size: 14px;\n            line-height: 6px;\n          }\n        }\n      }\n    }\n\n    .search .search-bar {\n      color: #ffffff;\n      background: #ffffff17;\n      box-shadow: none;\n    }\n\n    .student-notification i {\n      font-size: 1.5rem;\n    }\n  }\n\n  .header-bottom .title {\n    font: normal normal bold 22px/27px Proxima Nova;\n    letter-spacing: 0px;\n    color: #ffffff;\n    text-shadow: 0px 3px 6px #00000029;\n  }\n\n  &.mock-tests-eries-topnavbar .scroll-header {\n    position: relative;\n    background: linear-gradient(180deg, #4d5ee3, #f9c52d);\n  }\n\n  &.previous-paper-analysis-topnavbar .scroll-header {\n    position: relative;\n    background: linear-gradient(180deg, #30ffe3, #c698e9);\n  }\n\n  &.getreadyforexam-topnavbar .scroll-header {\n    position: relative;\n    background: linear-gradient(180deg, #ffcf10, #98e9b3);\n  }\n\n  &.bookmarks-topnavbar .scroll-header {\n    position: relative;\n    background: linear-gradient(180deg, #f7af4d, #2bb19e);\n  }\n\n  &.notes-topnavbar .scroll-header {\n    position: relative;\n    background: linear-gradient(180deg, #3a4ace, #fb7369);\n  }\n\n  &.exam-topnavbar .scroll-header {\n    position: relative;\n    background: linear-gradient(180deg, #d10781 0%, #cd43a2 2%, #c3daf5 100%);\n  }\n\n  &.videos-topnavbar .scroll-header {\n    position: relative;\n    background: linear-gradient(180deg, #d10451, #eb6d7e);\n\n    .navbar-nav .profile-img {\n      color: #000000;\n      background: #ffffff;\n      border: 1px solid #ffffff;\n    }\n  }\n\n  &.notification-topnavbar .scroll-header {\n    position: relative;\n    background: linear-gradient(180deg, #000000 0%, #5b2cf8 100%);\n    .navbar-nav .profile-img {\n      color: #000000;\n      background: #ffffff;\n      border: 1px solid #ffffff;\n    }\n  }\n  \n  &.blog-topnavbar .scroll-header {\n    position: relative;\n    background: linear-gradient(180deg, #000000 0%, #f8c52c 100%);\n    .navbar-nav .profile-img {\n      color: #000000;\n      background: #ffffff;\n      border: 1px solid #ffffff;\n    }\n  }\n}\n\n// modal-style\n.help-modal {\n  .modal-dialog-centered {\n    align-items: flex-end;\n  }\n\n  .modal-content {\n    background-color: transparent;\n    border: none;\n    margin-bottom: -28px;\n    pointer-events: painted;\n\n    .modal-header {\n      .close {\n        padding: 0;\n        color: #ff004e;\n        background: #fff !important;\n        border-radius: 50%;\n        height: 30px;\n        width: 30px;\n        line-height: 30px;\n        position: absolute;\n        top: 2px;\n        right: 8px;\n        z-index: 1;\n      }\n    }\n\n    .modal-body {\n      border: 1px solid rgba(0, 0, 0, 0.2);\n      border-radius: 0.3rem;\n\n      img {\n        @media screen and (min-width: 992px) {\n          width: 350px;\n          position: absolute;\n          bottom: 6px;\n          right: 0;\n          z-index: 1;\n        }\n\n        @media screen and (max-width: 991px) {\n          width: 320px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
